module.exports = __webpack_public_path__ + "media/images/logo-c8480004.png";